// src/componentes/Cuerpos/submoduloscomunes/SeleccionarPago/SeleccionarPagoModal.js

import React, { useState, useMemo, useEffect } from 'react';
import './SeleccionarPagoModal.css';
import PagoContadoForm from './formaspago/PagoContadoForm';
import PagoTarjetaForm from './formaspago/PagoTarjetaForm';
import Cargando from '../../../../Cargando';
import PuenteApi from '../../../../pageauth/PuenteApi';

const FORMAS_PAGO = ['CONTADO', 'TARJETA/QR', 'App LiderGas'];

const SeleccionarPagoModal = ({ isVisible, onClose, totalFactura, SetMensaje, operarioID }) => {
    // 1. Estados
    const [pagos, setPagos] = useState([]);
    const [selectedFormaPago, setSelectedFormaPago] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    // 2. Cálculos derivados
    const totalAPagar = useMemo(() => parseFloat(totalFactura) || 0, [totalFactura]);
    const totalPagosIngresados = useMemo(() =>
        pagos.reduce((acc, pago) => acc + parseFloat(pago.importe), 0),
        [pagos]
    );
    const restaIngresar = totalAPagar - totalPagosIngresados;
    const isTotalCubierto = restaIngresar <= 0.01;

    const { StartCargando, StopCargando } = Cargando()
    const { ObtenerPagosIntegrados, obtenerltimospagos, verificarPermisoUsuario } = PuenteApi()


    const [integracion, setIntegracion] = useState(null);
    const [mediopago, setMediopago] = useState([]);
    const [hayMasDeUnMedio, setHayMasDeUnMedio] = useState(false);
    const [selectedMedioPago, setSelectedMedioPago] = useState(null); // Medio de pago seleccionado


    const obtenermediospagos = async () => {
        const respuesta = await ObtenerPagosIntegrados();
        if (respuesta) {
            if (respuesta.success) {
                setIntegracion(respuesta.integracion);
                setMediopago(respuesta.mediopago);
                setHayMasDeUnMedio(respuesta.mediopago.length > 1);
            }
        }

    };

    // 3. Reseteo de estados al abrir/cerrar
    useEffect(() => {
        if (isVisible) {
            setPagos([]);
            setSelectedFormaPago(null);
            setIsProcessing(false);
            obtenermediospagos();
        }
    }, [isVisible, totalFactura]); // totalFactura añadido como dependencia para resetear

    // 4. Handlers
    const handleCancelar = () => {
        // SetMensaje("Info", "Operación de pago cancelada.", 2000);
        onClose("cancel");
    };

    const handleContinuar = () => {
        if (!isTotalCubierto) {
            SetMensaje("Error", "Debe cubrir el monto total ($" + totalAPagar.toFixed(2).replace('.', ',') + ") para continuar.", 3000);
            return;
        }

        if (0.0 > restaIngresar) {
            SetMensaje("Error", "Se esta cobrando mas de la cuenta", 3000);
            return;
        }

        setIsProcessing(true);
        StartCargando("Procesando solicitud...");
        // Generar el resumen en formato JSON
        const resumenPagos = pagos.reduce((acc, pago) => {
            const neto = parseFloat(pago.importe);
            let tipo = null;
            let cuotas = 0;
            let detalle = null;

            // Determinar tipo de pago, cuotas y detalle
            if (pago.tipo === "CONTADO") {
                tipo = pago.tipo;
                cuotas = 0; // No aplica para "CONTADO"
            } else if (pago.detalle && pago.detalle.includes("QR")) {
                tipo = "QR";
                cuotas = 1;
                detalle = pago.detalle;
            } else if (pago.detalle && pago.detalle.includes("Debito")) {
                tipo = "TARJETA";
                cuotas = 1;
                detalle = pago.detalle;
            } else if (pago.detalle && pago.detalle.includes("Credito")) {
                tipo = "TARJETA";
                cuotas = 2;
                detalle = pago.detalle;
            }

            // Verificamos si el tipo ya existe en el resumen
            const existingPayment = acc.find(item => item.tipo === tipo);

            if (existingPayment) {
                // Si ya existe, sumamos el importe y las cuotas
                existingPayment.importe = (parseFloat(existingPayment.importe) + neto).toFixed(2);
                existingPayment.cuotas += cuotas;
            } else {
                // Si no existe, lo agregamos como un nuevo pago
                acc.push({ tipo, importe: neto.toFixed(2), cuotas, detalle });
            }

            return acc;
        }, []);


        const responseJSON = {
            totalFactura: totalAPagar.toFixed(2),
            detallePagos: pagos,
            fecha: new Date().toISOString()
        };
        StopCargando();
        onClose("ok", responseJSON);
    };

    const addPayment = (pagoData) => {
        const montoRestante = restaIngresar;
        let importeFinal = parseFloat(pagoData.importe);

        // Ajustar el importe si es mayor que el monto restante
        if (importeFinal >= montoRestante && montoRestante > 0) {
            importeFinal = montoRestante;
        }

        // Verifica si ya existe un pago con el mismo importe y otros criterios que desees
        const pagoDuplicado = pagos.some(pago =>
            pago.importe === importeFinal.toFixed(2) &&
            pago.metodo === pagoData.metodo && // si el método de pago también es relevante
            pago.fecha === pagoData.fecha // o cualquier otro campo relevante
        );

        if (pagoDuplicado) {
            // Si ya existe un pago exactamente igual, no agregues el nuevo pago
            console.log("Este pago ya existe.");
            return;
        }

        // Si no es duplicado, agrega el pago
        setPagos(prevPagos => [
            ...prevPagos,
            { ...pagoData, importe: importeFinal.toFixed(2), id: Date.now() }
        ]);

        // Vuelve al modo de selección/resumen
        setSelectedFormaPago(null);
    };


    const removePayment = (paymentId) => {
        setPagos(prevPagos => prevPagos.filter(p => p.id !== paymentId));
        // SetMensaje("Info", "Pago eliminado correctamente.", 1500);
    };

    const handleSelectFormaPago = (forma) => {
        if (forma === 'App LiderGas') {
            SetMensaje("Informacion", "Seccion no disponible por el momento", 3000);
            setSelectedFormaPago(null);
        } else {
            setSelectedFormaPago(forma);
        }
    }

    if (!isVisible) return null;

    // 5. Renderizado de vistas de pago
    const renderPagoForm = () => {
        if (!selectedFormaPago) return null;

        const closeFormView = () => setSelectedFormaPago(null);

        const propsComunes = {
            restaIngresar: restaIngresar,
            addPayment: addPayment,
            SetMensaje: SetMensaje,
            onCloseView: closeFormView,
            integracion: integracion,
            mediopago: mediopago,
            hayMasDeUnMedio: hayMasDeUnMedio,
            setSelectedMedioPago: setSelectedMedioPago,
            selectedMedioPago: selectedMedioPago,
            obtenerltimospagos: obtenerltimospagos,
            operarioID: operarioID,
            verificarPermisoUsuario: verificarPermisoUsuario
        };

        switch (selectedFormaPago) {
            case 'CONTADO':
                return <PagoContadoForm {...propsComunes} />;
            case 'TARJETA/QR':
                return <PagoTarjetaForm {...propsComunes} />;
            default:
                return null;
        }
    };

    const isPagoFormActive = selectedFormaPago && selectedFormaPago !== 'App LiderGas';

    return (
        <div className="modal-overlay-pago">
            <div className="modal-content-pago">
                <div className="modal-title-pago">
                    <span className="pago-icono">$</span> Seleccioná la forma de pago
                </div>

                <div className="modal-body-pago">
                    {/* Botones de Forma de Pago */}
                    <div className="formas-pago">
                        {FORMAS_PAGO.map(forma => (
                            <button
                                key={forma}
                                className={`btn-forma-pago ${selectedFormaPago === forma && !isPagoFormActive ? 'activo' : ''}`}
                                onClick={() => handleSelectFormaPago(forma)}
                                disabled={isPagoFormActive}
                            >
                                {forma}
                            </button>
                        ))}
                    </div>

                    {/* Contenedor del Resumen/Formulario */}
                    <div className="panel-pago-principal">

                        {/* 5.1. Formulario Activo */}
                        {isPagoFormActive && (
                            <div className="pago-form-wrapper">
                                {renderPagoForm()}
                                <button className="btn-cancelar-form" onClick={() => setSelectedFormaPago(null)}>
                                    <span className='icono'>⬅️</span> Volver a pagos
                                </button>
                            </div>
                        )}

                        {/* 5.2. Resumen Activo */}
                        {!isPagoFormActive && (
                            <div className="resumen-pago">
                                <div className="linea-resumen total-a-pagar">
                                    <span className="label">Total a Pagar</span>
                                    <span className="valor-resumen">${totalAPagar.toFixed(2).replace('.', ',')}</span>
                                </div>

                                <div className="pagos-agregados-lista">
                                    <span className="label">Pagos Agregados:</span>
                                    {pagos.length === 0 ? (
                                        <div className="no-pagos">No hay ningún pago agregado...</div>
                                    ) : (
                                        pagos.map(p => (

                                            <div key={p.id} className="pago-item-wrapper">
                                                <div className="pago-item">
                                                    {p.tipo} - ${p.importe.replace('.', ',')}

                                                    {p.tipo === 'TARJETA' && p.detalle && (
                                                        <span className="pago-detalle-tarjeta">
                                                            {` (${p.detalle} )`}
                                                        </span>
                                                    )}

                                                    {p.tipo === 'QR' && p.detalle && (
                                                        <span className="pago-detalle-tarjeta">
                                                            {` (${p.detalle} ) `}
                                                            {p.detalle === 'Credito' && ` Cuotas: (${p.cuotas}) `}
                                                        </span>
                                                    )}
                                                </div>
                                                <button
                                                    className="btn-eliminar-pago"
                                                    onClick={() => removePayment(p.id)}
                                                    title="Eliminar este pago"
                                                >
                                                    ❌
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>

                                <div className="linea-resumen total-ingresado">
                                    <span className="label">Total Pagos Ingresados</span>
                                    <span className="valor-resumen">${totalPagosIngresados.toFixed(2).replace('.', ',')}</span>
                                </div>

                                <div className="linea-resumen resta-ingresar">
                                    <span className="label">Resta ingresar pagos por:</span>
                                    <span
                                        className="valor-resumen"
                                        style={{ color: restaIngresar != 0.0 ? '#ff002d' : '#00a100' }}
                                    >
                                        ${restaIngresar.toFixed(2).replace('.', ',')}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-footer-pago">
                    <button className="boton-pago-cancelar" onClick={handleCancelar} disabled={isProcessing}>
                        ❌ Cancelar
                    </button>

                    <button
                        className="boton-pago-continuar"
                        onClick={handleContinuar}
                        disabled={!isTotalCubierto || isProcessing || isPagoFormActive}
                    >
                        {isProcessing ? 'Procesando...' : '✅ Continuar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SeleccionarPagoModal;